import { Fragment, useState, useEffect, useCallback } from 'react';
import MemberStats from './MemberStats';
import TrackMapMulti from './TrackMapMulti.js';
import Box from '@mui/material/Box';
import SessionInfo from './SessionInfo';
import Mqtt5Connector from './Mqtt5Connector.js';
import { fetchUserProfiles } from '../shared/fetchProfiles.js';
import Expander from '../shared/Expander.js';

const eventDetails = {
  event_name: 'Speed SF',
  sessions: [
    {
      name: 'Session One',
      startTime: '2024-02-29',
      duration: 20,
      session_type: 'practice',
      is_racehero_session: false,
      session_conditions: 'dry',
      session_notes: '',
      racers: ['kirk', 'john'],
    },
    {
      name: 'session two',
      startTime: '2024-02-29',
      duration: 20,
      session_type: 'practice',
      is_racehero_session: false,
      session_conditions: 'dry',
      session_notes: '',
      racers: ['kirk', 'john'],
    },
    {
      name: 'session three',
      startTime: '2024-02-29',
      duration: 20,
      session_type: 'practice',
      is_racehero_session: false,
      session_conditions: 'dry',
      session_notes: '',
      racers: ['kirk', 'john'],
    },
    {
      name: 'session four',
      startTime: '2024-02-29',
      duration: 20,
      session_type: 'practice',
      is_racehero_session: false,
      session_conditions: 'dry',
      session_notes: '',
      racers: ['kirk', 'john'],
    },
  ],
  track_details: {
    name: 'Sonoma Raceway',
    trackconfiguration: 'indy',
    gps_bounds: [
      [38.167309043518166, -122.46494293212892],
      [38.15730431188241, -122.45026588439943],
    ],
    startLine: [
      { lat: 38.161631990764214, lng: -122.45509386062623 },
      { lat: 38.16179648811051, lng: -122.45491683483125 },
      // { lat: 38.161564504566066, lng: -122.45522260665895 },
      // { lat: 38.16167416960633, lng: -122.4551045894623 },
    ],
    startLineFormatted: [
      [38.161631990764214, -122.45509386062623],
      [38.16179648811051, -122.45491683483125],
      // [38.161564504566066, -122.45522260665895],
      // [38.16167416960633, -122.4551045894623],
    ],
  },
};

function TeamVitals() {
  const [telemetryPayload, setTelemetryPayload] = useState({});
  const [userProfiles, setUserProfiles] = useState([]);

  useEffect(() => {
    async function wrapper() {
      setUserProfiles(await fetchUserProfiles());
    }
    wrapper();
  }, []);

  const liftTelemetryPayload = useCallback((payload, devicename) => {
    setTelemetryPayload((previousMessages) => {
      if (!previousMessages.hasOwnProperty(devicename)) {
        previousMessages[devicename] = [];
      }
      const recents = previousMessages[devicename].slice(-100);
      return { ...previousMessages, [devicename]: [...recents, payload] };
    });
  }, []);
  return (
    <Fragment>
      <Box>
        <SessionInfo event_details={eventDetails} />
        <Expander headerText={eventDetails?.track_details?.name}>
          <TrackMapMulti
            my_data={telemetryPayload}
            track_details={eventDetails?.track_details}
            userProfiles={userProfiles}
          />
        </Expander>
        {userProfiles.length > 0 &&
          userProfiles.map((member, index) => {
            return (
              <Fragment key={index}>
                <Mqtt5Connector
                  liftTelemetryPayload={liftTelemetryPayload}
                  devicename={member.htrDevice}
                />
                <MemberStats
                  memberObject={member}
                  data={telemetryPayload[member.htrDevice] || []}
                  startlinecoords={eventDetails?.track_details.startLine}
                />
              </Fragment>
            );
          })}
      </Box>
    </Fragment>
  );
}

export default TeamVitals;
